// Item #9 — revenue attribution. Mirrors LeadG.Shared/ViewModels/RevenueAttribution.
// Numeric values must match the backend SentBySource enum exactly (Confirmed = 1, not 0).
export var SentBySource;
(function (SentBySource) {
    SentBySource[SentBySource["Confirmed"] = 1] = "Confirmed";
    SentBySource[SentBySource["Inferred"] = 2] = "Inferred";
    SentBySource[SentBySource["LeadOwnerFallback"] = 3] = "LeadOwnerFallback";
    SentBySource[SentBySource["ManualOverride"] = 4] = "ManualOverride";
})(SentBySource || (SentBySource = {}));
